// models
import {
  headerName,
  headerText
} from "@/model/common/dataTable/dataTableConst";
import {
  fieldName,
  fieldText
} from "@/model/employeeAccess/tasks/constants/myTasksConst";
import {
  taskDetailsTimeFieldName,
  taskDetailsTimeFieldText
} from "@/model/employeeAccess/tasks/constants/taskDetailsTimeConst";
import {
  taskDetailsTimeOffFieldName,
  taskDetailsTimeOffFieldText
} from "@/model/employeeAccess/tasks/constants/taskDetailsTimeOffConst";
import { MyTasks_v2 } from "@/model/employeeAccess/tasks/MyTasks_v2";
import { entities } from "@/model/employeeAccess/modules";

// design
import {
  Color,
  variantType,
  variantNumber,
  colorTheme
} from "@/design/colors/Color";

// services
import apiEmployeeAccess from "@/services/employeeAccess/api/apiEmployeeAccess";

// common
import {
  approve_leave_request,
  assign_task,
  task_call_off
} from "@/common/endpoints";

// utils
import {
  getLocalStorageItem,
  setLocalStorageItem
} from "@/utils/localStorageUtility";

/**
 * User Local Storage Keys
 * @type {Readonly<{detailsViewTableScroll: Boolean}>}
 */
const localStorageKey = Object.freeze({
  detailsViewTableScroll: "detailsViewTableScroll"
});

/**
 * Store Details View Table Scroll to the local Storage
 * @param {Boolean} item:
 */
const storeDetailsViewTableScroll = item => {
  setLocalStorageItem(localStorageKey.detailsViewTableScroll, item);
};
/**
 * Get Stored Details View Table Scroll from local Storage
 * @returns {String|string}
 */
const getStoredDetailsViewTableScroll = () => {
  return getLocalStorageItem(localStorageKey.detailsViewTableScroll);
};
/**
 * Departments Entity Name
 * @type {string}
 */
const entityName = entities.Tasks;

/**
 * create New My Task
 * @param name
 * @returns {MyTasks}
 */
const createNewMyTask = (name = "") => new MyTasks_v2(name);

const headers = Object.freeze([
  // {
  //   text: fieldText.taskQueueId,
  //   value: fieldName.taskQueueId,
  //   visible: true
  // },
  {
    text: fieldText.activityType,
    value: fieldName.activityType,
    visible: true
  },
  {
    text: fieldText.processName,
    value: fieldName.processName,
    visible: true
  },
  {
    text: fieldText.assignedTo,
    value: fieldName.assignedTo,
    visible: true
  },
  {
    text: fieldText.initiatedBy,
    value: fieldName.initiatedBy,
    visible: true
  },
  {
    text: fieldText.initiateDate,
    value: fieldName.initiateDate,
    visible: true
  },
  {
    text: fieldText.dueDate,
    value: fieldName.dueDate,
    visible: true
  },
  {
    text: fieldText.remainingTime,
    value: fieldName.remainingTime,
    visible: true
  },
  {
    text: headerText.actions,
    value: headerName.actions,
    sortable: false,
    align: "end",
    visible: true
  }
]);

const timeHeaders = Object.freeze([
  {
    text: taskDetailsTimeFieldText.id,
    value: taskDetailsTimeFieldName.id,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.assignmentNumber,
    value: taskDetailsTimeFieldName.assignmentNumber,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.task,
    value: taskDetailsTimeFieldName.task,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.clockIn,
    value: taskDetailsTimeFieldName.clockIn,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.clockOut,
    value: taskDetailsTimeFieldName.clockOut,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.selectedDate,
    value: taskDetailsTimeFieldName.selectedDate,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.totalHours,
    value: taskDetailsTimeFieldName.totalHours,
    visible: true
  },
  {
    text: taskDetailsTimeFieldText.comment,
    value: taskDetailsTimeFieldName.comment,
    visible: true
  }
]);

const timeOffHeaders = Object.freeze([
  {
    text: taskDetailsTimeOffFieldText.id,
    value: taskDetailsTimeOffFieldName.id,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.assignmentNumber,
    value: taskDetailsTimeOffFieldName.assignmentNumber,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.startDate,
    value: taskDetailsTimeOffFieldName.startDate,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.endDate,
    value: taskDetailsTimeOffFieldName.endDate,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.hoursType,
    value: taskDetailsTimeOffFieldName.hoursType,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.rqstHours,
    value: taskDetailsTimeOffFieldName.rqstHours,
    visible: true
  },
  {
    text: taskDetailsTimeOffFieldText.finalStatus,
    value: taskDetailsTimeOffFieldName.finalStatus,
    visible: true
  }
]);

const getItemFieldColor = () => {
  return new Color(
    colorTheme.info,
    variantType.lighten,
    variantNumber.n1
  ).getClassColor();
};

async function postToApi(url, payload) {
  return apiEmployeeAccess.post(url, payload);
}

async function patchToApi(url, payload) {
  return apiEmployeeAccess.wfApiPatch(url, payload);
}

async function postTask(payload) {
  const response = await postToApi(approve_leave_request, payload);
  console.log(response);
  const data = response.data;
  if (data.code === 200) {
    return Promise.resolve(data.message);
  } else {
    return Promise.reject(data.message);
  }
}

async function callOffTask(payload) {
  const response = await patchToApi(task_call_off + payload, "");
  console.log(response);
  const data = response.data;
  if (data.code === 200) {
    return Promise.resolve(data.message);
  } else {
    return Promise.reject(data.message);
  }
}

async function assignTask(payload) {
  const response = await patchToApi(assign_task, payload);
  console.log(response);
  const data = response.data;
  if (data.code === 200) {
    return Promise.resolve(data.message);
  } else {
    return Promise.reject(data.message);
  }
}

export {
  assignTask,
  callOffTask,
  timeOffHeaders,
  timeHeaders,
  entityName,
  fieldName,
  fieldText,
  headers,
  getItemFieldColor,
  postTask,
  createNewMyTask,
  storeDetailsViewTableScroll,
  getStoredDetailsViewTableScroll
};
